export default __webpack_public_path__ + "static/media/640_portfolio03-nl-mobile.086799af.png";